import { Loading } from '@/components/loading/Loading';

import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSignOut } from '../../services/authentication/hooks/auth';
import { PageTitle } from '../../utils/Title';

export const SignOut: FC = () => {
  const signOut = useSignOut();
  const navigate = useNavigate();
  useEffect(() => {
    void (async () => {
      await signOut();
      navigate('/');
    })();
  }, [signOut, navigate]);

  return (
    <>
      <PageTitle>Sign out</PageTitle>
      <Loading className="h-screen" />
    </>
  );
};
